import { FlexColumn, FlexRow } from '@gorila-shared-ui/components';
import { LabelLarge } from 'baseui/typography';
import { useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import useUpdateEffect from '../../../hooks/useUpdateEffect';
import { capturingTimelineMapEventState, timelineEvidenceEventsState } from '../../../storage/streaming';
import FloatingTopCard from '../../layout/cards/FloatingTopCard';
import CapturingVideoEvidence from './CapturingVideoEvidence';

function CapturingVideoEvidences() {
  const { theme, css } = useStyles();
  const events = useRecoilValue(timelineEvidenceEventsState);
  const mapEvent = useRecoilValue(capturingTimelineMapEventState);

  useUpdateEffect(() => {
    if (mapEvent?.key) {
      const evidence = document.getElementById(mapEvent.key);
      evidence?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [mapEvent]);

  if (!events) return null;

  return (
    <FloatingTopCard name="evidences">
      <FlexColumn
        gap={theme.sizing.scale300}
        classNames={css({ height: '100%' })}
      >
        <LabelLarge
          margin={0}
          style={{ fontWeight: theme.typography.HeadingXSmall.fontWeight }}
        >
          Evidencias disponibles
        </LabelLarge>
        <FlexRow classNames={css({ overflowX: 'auto' })}>
          {events.map((event, index) => {
            return (
              <CapturingVideoEvidence
                event={event}
                key={index}
                highlight={mapEvent?.key === event.key}
              />
            );
          })}
        </FlexRow>
      </FlexColumn>
    </FloatingTopCard>
  );
}

export default CapturingVideoEvidences;
